import {Component, Input, OnInit} from '@angular/core';
import {AppComponent} from "../../../app.component";
import {ListItem} from "../../../objects/listItem";
import {SharedDataService} from "../../../services/shared-data.service";
import {CdkDragDrop, moveItemInArray, transferArrayItem} from "@angular/cdk/drag-drop";
import {AppEvent} from "../../../objects/appEvent";
import {SubscriptionLike} from "rxjs/index";
import {FormControl, FormGroup} from "@angular/forms";

@Component({
  selector: 'app-user-dragger-popup',
  templateUrl: './user-dragger-popup.component.html',
  styleUrls: ['./user-dragger-popup.component.css']
})
export class UserDraggerPopupComponent implements OnInit {

  @Input() application: AppComponent;
  @Input() payload: object;

  private sharedEventSubscription: SubscriptionLike;
  state: string = 'loading';
  errMsg: string = '';
  pickFrom: ListItem[] = [];
  pickFromFiltered: ListItem[] = [];
  pickTo: ListItem[] = [];
  pickToFiltered: ListItem[] = [];
  public componentForm: FormGroup = new FormGroup({});
  public searchInput: FormControl = new FormControl('');

  constructor(private sharedDataService: SharedDataService) { }

  ngOnInit(): void {
    this.sharedEventSubscription = this.sharedDataService.globalEventObservable$.subscribe(
      appEvent => {
        if (appEvent.type === AppEvent.DRAGGER_USERS_LOADING) {
          this.state = 'loading';
        }
        if (appEvent.type === AppEvent.DRAGGER_USERS_ERROR) {
          this.state = 'error';
          this.errMsg = appEvent.data['error']['errMsg']
        }
        if (appEvent.type === AppEvent.DRAGGER_USERS_LOADED) {
          this.state = 'default';
          this.pickFrom = appEvent.data['pickFrom']
          this.pickTo = appEvent.data['pickTo']
          this.pickFromFiltered = [...this.pickFrom];
          this.pickToFiltered = [...this.pickTo];
        }
    });
    this.componentForm.addControl('searchInput',this.searchInput);
    this.searchInput.valueChanges.subscribe(value => {
      this.filterList(value)
    })
  }

  filterList(filterValue:string): void {
    if (!filterValue) {
      this.pickFromFiltered = [...this.pickFrom];
      this.pickToFiltered = [...this.pickTo];
    } else {
      this.pickFromFiltered = [...this.pickFrom.filter(user => user.filter_string.indexOf(filterValue) != -1 )]
      this.pickToFiltered = [...this.pickTo.filter(user => user.filter_string.indexOf(filterValue) != -1 )]
    }
  }
  ngOnDestroy() {
    this.sharedEventSubscription.unsubscribe();
  }

  dropItem(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);
      let profileID = event.container.data[event.currentIndex]['itemFullData']['id'];
      let targetItem = event.container.data[event.currentIndex];
      let action = event.container.id === 'drop-list-2' ? 'add' : 'remove';
      //also move between pickFrom/pickTo arrays as they are main source for the lists
      if(action == 'add') {
        const idx = this.pickFrom.findIndex(profile => profile['itemFullData']['id'] == profileID)
        transferArrayItem(this.pickFrom,this.pickTo,idx,event.currentIndex);
      } else {
        const idx = this.pickTo.findIndex(profile => profile['itemFullData']['id'] == profileID)
        transferArrayItem(this.pickTo,this.pickFrom,idx,event.currentIndex);
      }
      let appEvent = new AppEvent(AppEvent.DRAGGER_USER_CHANGE,{
        context: this.payload['context'], item_id: this.payload['item_id'],
        profile_id: profileID, action: action, targetItem: targetItem
      })
      this.sharedDataService.pushAppEvent(appEvent);
    }
  }

}
